// ─── PanelWorld.jsx — FIXED ───────────────────────────
import { useEffect, useRef } from "react";
import { PanelNav } from "../Bootoverlay/Bootoverlay";

export default function PanelWorld({ onNav }) {
    const convoyRef = useRef(null);
    const offsetRef = useRef(0);
    const rafRef = useRef(null);

    useEffect(() => {
        const convoy = convoyRef.current;
        if (!convoy) return;

        function animateConvoy() {
            offsetRef.current += 0.25;
            convoy.style.transform = `translateX(-${offsetRef.current}px)`;
            if (offsetRef.current > convoy.scrollWidth / 2) offsetRef.current = 0;
            rafRef.current = requestAnimationFrame(animateConvoy);
        }

        rafRef.current = requestAnimationFrame(animateConvoy);
        return () => cancelAnimationFrame(rafRef.current);
    }, []);

    return (
        <section className="vk-panel vk-panel-wide" id="panel-world">
            {/* Background convoy */}
            <div className="vk-world-bg">
                <img
                    ref={convoyRef}
                    src="/images/convoy-side.png"
                    alt="Vegas Karts convoy"
                    className="vk-convoy-img"
                />
                <div className="vk-world-overlay" />
            </div>

            {/* Text & stats overlay */}
            <div className="vk-lore-overlay vk-anim-fade-slide">
                <div className="vk-lore-block vk-anim-slide">
                    {/* FIX: Updated title text */}
                    
                    <h2 className="vk-lore-heading" style={{borderBottom:"none"}}>
                        LAS VEGAS.<br />
                        THE STREETS<br />
                        <span className="orange">ARE YOURS.</span>
                    </h2>
                </div>

                <div className="vk-lore-block vk-anim-slide" style={{ animationDelay: "0.1s" }}>
                    <div className="vk-lore-tag">// VEHICLE: VEGAS KARTS STREET KART</div>
                    <p className="vk-lore-body">
                        Open-wheel karts on the streets of Vegas. No track. No guardrails.
                        Just four wheels, an exposed engine, and the city grid.
                    </p>
                     <div className="vk-left-navs-wrapper">
                        <PanelNav prev={0} next={2} label="02 / 08 — CONVOY" onNav={onNav} />
                    </div>
                </div>

                <div className="vk-lore-block vk-anim-slide" style={{ animationDelay: "0.2s" }}>
                    <div className="vk-lore-tag">// OBJECTIVE</div>
                    <p className="vk-lore-body">
                        Select your mission. <br/>
                        Register your callsign. <br/>
                        Deploy Winter 2026.
                    </p>
                    <button className="vk-btn-ghost" onClick={() => onNav(3)}>
                        SELECT Tours ▶
                    </button>
                </div>
            </div>

            {/* FIX: PanelNav with centered carousel class */}
            {/* <PanelNav prev={0} next={2} label="02 / 07 — CONVOY" onNav={onNav} /> */}
        </section>
    );
}